import { VIEW_DATE_FORMAT } from 'utils/constants/date';
import { formatDate } from 'utils/date';

import Information from 'bloko/blocks/information';
import Text from 'bloko/blocks/text';

import useTrls from 'hooks/translation/useTrls';

import Table from 'components/Table';

import TableBody from 'components/Table/TableBody';
import TableCell from 'components/Table/TableCell';
import TableRow from 'components/Table/TableRow';

import { useSelector } from 'store/utils';

const AgreementInfo = () => {
    const { agreement, hhPayerId } = useSelector((state) => state.payerDetail.payer);
    const trl = useTrls();

    if (hhPayerId && agreement?.number && agreement?.createdAt) {
        return (
            <Table fullWidth withStripes bordered>
                <TableBody>
                    <TableRow>
                        <TableCell>
                            <Text strong>{trl('admin.PayerDetail.Agreement.number')}</Text>
                        </TableCell>
                        <TableCell>{agreement.number}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            <Text strong>{trl('admin.PayerDetail.Agreement.date')}</Text>
                        </TableCell>
                        <TableCell>{formatDate(agreement.createdAt, VIEW_DATE_FORMAT)}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        );
    }

    return <Information>{trl('admin.Payers.Payer.not.agreement')}</Information>;
};

export default AgreementInfo;
